export const nameRegex = `^[-a-zA-Z .'\u00C0-\u00FF]{2,150}$`;

export const passwordRegex = `^(?=.*[a-zA-Z])(?=.*[0-9])\\S{8,}$`;

export const passwordMaxLength = 72;
